import { Fragment, useEffect, useState } from "react";
import { getAdminHeaders } from "./adminApi";

const TABS = [
  { id: "audit", label: "漂流瓶审核" },
  { id: "reports", label: "举报工单" },
  { id: "configs", label: "配额与城市开关" },
];

export default function AdminPlanet() {
  const [tab, setTab] = useState("audit");
  const [message, setMessage] = useState("");

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-800">漂流星球</h2>
        <p className="text-sm text-gray-500 mt-1">
          审核漂流瓶、处理举报、调整日配额与种子城随机开关。
        </p>
      </div>

      <div className="flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={`px-4 py-2 rounded-xl text-sm font-medium ${
              tab === t.id ? "bg-blue-600 text-white" : "bg-white border"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {message && (
        <p className="text-sm text-blue-700 bg-blue-50 border border-blue-100 rounded-xl px-3 py-2">
          {message}
        </p>
      )}

      {tab === "audit" && <AuditPanel setMessage={setMessage} />}
      {tab === "reports" && <ReportsPanel setMessage={setMessage} />}
      {tab === "configs" && <ConfigsPanel setMessage={setMessage} />}
    </div>
  );
}

function AuditPanel({ setMessage }) {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [auditStatus, setAuditStatus] = useState("pending");
  const [notes, setNotes] = useState({});
  const [expanded, setExpanded] = useState(null);

  const load = async () => {
    const params = new URLSearchParams({ page: "1", page_size: "30" });
    if (auditStatus) params.set("audit_status", auditStatus);
    const res = await fetch(`/api/planet/admin/bottles?${params}`, {
      headers: getAdminHeaders(),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "加载失败");
    setItems(data.items || []);
    setTotal(data.total || 0);
  };

  useEffect(() => {
    load().catch((e) => setMessage(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auditStatus]);

  const act = async (id, action) => {
    setMessage("");
    const res = await fetch(`/api/planet/admin/bottles/${id}/${action}`, {
      method: "POST",
      headers: getAdminHeaders(true),
      body: JSON.stringify({ note: notes[id] || "" }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "操作失败");
    setMessage(action === "approve" ? "已通过并尝试匹配" : "已驳回");
    await load();
  };

  const rematch = async () => {
    const res = await fetch(`/api/planet/admin/match-queued`, {
      method: "POST",
      headers: getAdminHeaders(true),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "失败");
    setMessage(`重新匹配完成：${data.matched} 个`);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap gap-3 items-center">
        <select
          value={auditStatus}
          onChange={(e) => setAuditStatus(e.target.value)}
          className="border rounded-xl px-3 py-2 text-sm"
        >
          <option value="pending">待审核</option>
          <option value="approved">已通过</option>
          <option value="rejected">已驳回</option>
          <option value="">全部</option>
        </select>
        <button
          type="button"
          onClick={() => rematch().catch((e) => setMessage(e.message))}
          className="px-3 py-2 rounded-xl bg-slate-800 text-white text-sm"
        >
          处理排队匹配
        </button>
        <span className="text-sm text-gray-500">共 {total} 条</span>
      </div>

      <div className="bg-white rounded-2xl border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="px-4 py-3">ID</th>
              <th className="px-4 py-3">发送者</th>
              <th className="px-4 py-3">路径</th>
              <th className="px-4 py-3">状态</th>
              <th className="px-4 py-3">操作</th>
            </tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <Fragment key={b.id}>
                <tr className="border-t">
                  <td className="px-4 py-3">
                    <button
                      type="button"
                      className="text-blue-600"
                      onClick={() => setExpanded(expanded === b.id ? null : b.id)}
                    >
                      #{b.id}
                    </button>
                  </td>
                  <td className="px-4 py-3">{b.sender_id}</td>
                  <td className="px-4 py-3">
                    {b.origin_city || "?"} → {b.dest_city || "?"} ({b.deliver_mode})
                  </td>
                  <td className="px-4 py-3">
                    {b.audit_status}/{b.status}
                  </td>
                  <td className="px-4 py-3 space-x-2">
                    {b.audit_status === "pending" && (
                      <>
                        <button
                          type="button"
                          className="text-green-700"
                          onClick={() => act(b.id, "approve").catch((e) => setMessage(e.message))}
                        >
                          通过
                        </button>
                        <button
                          type="button"
                          className="text-rose-600"
                          onClick={() => act(b.id, "reject").catch((e) => setMessage(e.message))}
                        >
                          驳回
                        </button>
                      </>
                    )}
                  </td>
                </tr>
                {expanded === b.id && (
                  <tr className="bg-slate-50">
                    <td colSpan={5} className="px-4 py-3 space-y-2">
                      {(b.messages || []).map((m) => (
                        <div key={m.id} className="text-sm">
                          <span className="text-gray-400">R{m.round_no}: </span>
                          {m.content}
                          {m.image_path && (
                            <a
                              className="ml-2 text-blue-600"
                              href={m.image_path}
                              target="_blank"
                              rel="noreferrer"
                            >
                              图片
                            </a>
                          )}
                        </div>
                      ))}
                      <input
                        className="border rounded-lg px-2 py-1 w-full max-w-md"
                        placeholder="审核备注"
                        value={notes[b.id] || ""}
                        onChange={(e) =>
                          setNotes((prev) => ({ ...prev, [b.id]: e.target.value }))
                        }
                      />
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}
            {!items.length && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-gray-400">
                  暂无数据
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ReportsPanel({ setMessage }) {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("open");

  const load = async () => {
    const params = new URLSearchParams({ page: "1", page_size: "40", status });
    const res = await fetch(`/api/planet/admin/reports?${params}`, {
      headers: getAdminHeaders(),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "加载失败");
    setItems(data.items || []);
  };

  useEffect(() => {
    load().catch((e) => setMessage(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const close = async (id) => {
    const res = await fetch(`/api/planet/admin/reports/${id}`, {
      method: "PATCH",
      headers: getAdminHeaders(true),
      body: JSON.stringify({ status: "closed", admin_note: "已处理" }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "失败");
    setMessage("工单已关闭");
    await load();
  };

  return (
    <div className="space-y-4">
      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        className="border rounded-xl px-3 py-2 text-sm"
      >
        <option value="open">未处理</option>
        <option value="closed">已关闭</option>
        <option value="">全部</option>
      </select>
      <div className="bg-white rounded-2xl border divide-y">
        {items.map((r) => (
          <div key={r.id} className="p-4 flex flex-wrap justify-between gap-3 text-sm">
            <div>
              <p className="font-medium">
                #{r.id} · {r.reason}
              </p>
              <p className="text-gray-500 mt-1">
                举报人 {r.reporter_id}
                {r.target_user_id ? ` → 用户 ${r.target_user_id}` : ""}
                {r.bottle_id ? ` · 瓶 #${r.bottle_id}` : ""}
              </p>
              <p className="mt-1">{r.detail}</p>
            </div>
            {r.status === "open" && (
              <button
                type="button"
                className="h-fit px-3 py-1.5 rounded-xl bg-slate-800 text-white"
                onClick={() => close(r.id).catch((e) => setMessage(e.message))}
              >
                关闭工单
              </button>
            )}
          </div>
        ))}
        {!items.length && <p className="p-8 text-center text-gray-400">暂无举报</p>}
      </div>
    </div>
  );
}

function ConfigsPanel({ setMessage }) {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});

  const load = async () => {
    const res = await fetch(`/api/planet/admin/configs`, { headers: getAdminHeaders() });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "加载失败");
    setItems(data.items || []);
    const d = {};
    (data.items || []).forEach((row) => {
      d[row.key] = row.value;
    });
    setDrafts(d);
  };

  useEffect(() => {
    load().catch((e) => setMessage(e.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async (key) => {
    const res = await fetch(`/api/planet/admin/configs`, {
      method: "PUT",
      headers: getAdminHeaders(true),
      body: JSON.stringify({ key, value: drafts[key] ?? "" }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.detail || "保存失败");
    setMessage(`已保存 ${key}`);
    await load();
  };

  return (
    <div className="bg-white rounded-2xl border divide-y">
      {items.map((row) => (
        <div key={row.key} className="p-4 space-y-2">
          <div className="flex justify-between gap-2 text-sm">
            <code className="font-medium">{row.key}</code>
            <button
              type="button"
              className="text-blue-600"
              onClick={() => save(row.key).catch((e) => setMessage(e.message))}
            >
              保存
            </button>
          </div>
          <textarea
            className="w-full border rounded-xl px-3 py-2 text-sm font-mono min-h-[64px]"
            value={drafts[row.key] ?? ""}
            onChange={(e) => setDrafts((prev) => ({ ...prev, [row.key]: e.target.value }))}
          />
          <p className="text-xs text-gray-400">
            city_random_enabled 为 JSON，如 {`{"合肥":true,"上海":false}`}；关闭后该城不可随机漂流。
          </p>
        </div>
      ))}
    </div>
  );
}
